import { render } from "./PostsTable.vue?vue&type=template&id=5051f0e2"
import script from "./PostsTable.vue?vue&type=script&lang=js"
export * from "./PostsTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__